/**
 * @generated SignedSource<<7cad008263546a970a215307458695c5>>
 * @relayHash 3e127a8a0f105d7dd3ffaf6658d29ff9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21aece67f1d4694a9ebcffa7e9910b5c638b92b86e44e42e66847c971c685c75

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomFiltersLoaderQuery$variables = {
  boardId: string;
};
export type CustomFiltersLoaderQuery$data = {
  readonly boardScope: {
    readonly customFilters: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CardCustomFiltersFragmentRef">;
    } | null | undefined>;
    readonly " $fragmentSpreads": FragmentRefs<"CardCustomFilterBoardScopeFragmentRef" | "ExpandedCardCustomFilterBoardScopeFragmentRef">;
  };
};
export type CustomFiltersLoaderQuery = {
  response: CustomFiltersLoaderQuery$data;
  variables: CustomFiltersLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CustomFiltersLoaderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "CustomFilter",
                "kind": "LinkedField",
                "name": "customFilters",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "CardCustomFiltersFragmentRef"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.customFilters"
            },
            {
              "kind": "FragmentSpread",
              "name": "CardCustomFilterBoardScopeFragmentRef"
            },
            {
              "kind": "FragmentSpread",
              "name": "ExpandedCardCustomFilterBoardScopeFragmentRef"
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomFiltersLoaderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFilter",
            "kind": "LinkedField",
            "name": "customFilters",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "concreteType": "FilterQuery",
                "kind": "LinkedField",
                "name": "filterQuery",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "sanitisedJql"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errors"
                  }
                ]
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "21aece67f1d4694a9ebcffa7e9910b5c638b92b86e44e42e66847c971c685c75",
    "metadata": {},
    "name": "CustomFiltersLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9a24a10cb36d4bf37d5ade9f70e0437e";

export default node;
